export const LOADING = 'LOADING'
export const GET_AVATAR_RESPONSE = 'GET_AVATAR_RESPONSE'
export const GET_AVATARS_RESPONSE = 'GET_AVATARS_RESPONSE'
export const CREATE_AVATAR_RESPONSE = 'CREATE_AVATAR_RESPONSE'
export const SWAP_AVATAR_RESPONSE = 'SWAP_AVATAR_RESPONSE'
